import React, { ReactNode } from "react";
import styles from "./Section.module.scss";
import Spline01 from "@/Atoms/Splines/Spline01";

export type SectionProps = {
  children?: ReactNode,
  content?: ReactNode,
  thin?: boolean,
  /**
   * make section background --beigedark
   */

  dark?: boolean,
  /**
   * make section background --beigedarker
   */
  darker?: boolean,
  /**
   * make section background white
   */
  white?: boolean,
  /**
   * make section background --beige
   */
  light?: boolean,
  /**
   * make section background --beigelight
   */
  lighter?: boolean,
  whiteInner?: boolean,
  lighterInner?: boolean,
  lightInner?: boolean,
  darkInner?: boolean,
  darkerInner?: boolean,
  bordered?: boolean,
  wide?: boolean,
  fullWidth?: boolean,
  reverse?: boolean,

  title?: string
  subtitle?: string | ReactNode
  titleAs?: keyof React.JSX.IntrinsicElements;

  className?: string,
  containerClassName?: string,
  contentClassName?: string,
  center?: boolean,
  curl?: boolean,
  image?: any,
  highImage?: boolean,
  coverImage?: boolean,
  stretchImage?: boolean,
  coverImageFlush?: boolean,
  imageAlt?: string,
  imageClassName?: string,
  imageBackgroundColor?: 'white' | 'lighter' | 'light' | 'dark' | 'darker',
  /**
   * decorative photo behind the whole section, fading into the section background on the left
   */
  backgroundImage?: string,
  style?: React.CSSProperties
}

export default (
  {
    children,
    thin,
    white,
    light,
    lighter,
    dark,
    darker,
    whiteInner,
    lighterInner,
    lightInner,
    darkInner,
    darkerInner,
    bordered,
    wide,
    fullWidth,
    reverse,
    title,
    subtitle,
    titleAs: TitleTag = 'h2',
    content,

    className,
    containerClassName,
    contentClassName,
    center,
    curl,
    image,
    highImage,
    coverImage,
    coverImageFlush,
    stretchImage,
    imageAlt,
    imageClassName,
    imageBackgroundColor,
    backgroundImage,
    style,
  }: SectionProps
) => {

  const hasInner = whiteInner || lighterInner || lightInner || darkInner || darkerInner;
  const sectionClassNames = [
    styles.section,
    white && styles.white,
    light && styles.light,
    lighter && styles.lighter,
    dark && styles.dark,
    darker && styles.darker,
    curl && styles.hasCurl,
    hasInner && styles.hasInner,
    wide && styles.wide,
    fullWidth && styles.fullWidth,
    backgroundImage && styles.hasBackground,
    className
  ].filter(Boolean).join(' ')

  const containerClassNames = [
    styles.container,
    thin && styles.thin,
    whiteInner && styles.whiteInner,
    lighterInner && styles.lighterInner,
    lightInner && styles.lightInner,
    darkInner && styles.darkInner,
    darkerInner && styles.darkerInner,
    center && styles.center,
    bordered && styles.bordered,
    reverse && styles.reverse,
    coverImageFlush && styles.coverImageFlush,
    stretchImage && styles.stretchImage,
    containerClassName
  ].filter(Boolean).join(' ')

  const imageClassNames = [
    styles.image,
    imageBackgroundColor === 'white' && styles.white,
    imageBackgroundColor === 'lighter' && styles.lighter,
    imageBackgroundColor === 'light' && styles.light,
    imageBackgroundColor === 'dark' && styles.dark,
    imageBackgroundColor === 'darker' && styles.darker,
    highImage && styles.highImage,
    coverImage && styles.coverImage,
    imageClassName,
  ].filter(Boolean).join(' ')

  const contentClassNames = [
    styles.content,
    contentClassName
  ].filter(Boolean).join(' ')

  return <section className={sectionClassNames}>
    {backgroundImage && <div className={styles.backdrop}>
      <img src={backgroundImage} alt="" />
    </div>}
    <div className={containerClassNames} style={style}>
      <div>
        <div className={contentClassNames}>
          {(title || subtitle) && <div className={styles.header}>
            {title && <TitleTag>{title}</TitleTag>}
            {subtitle && (typeof subtitle === "string" ? <p>{subtitle}</p> : subtitle)}
          </div>}
          {content}
          {children}
        </div>
        {image && <div className={imageClassNames}>
          <img src={image} alt={imageAlt ?? ''} />
          {imageAlt && <div className={styles.imageAlt}>{imageAlt}</div>}
        </div>}
      </div>
    </div>
    {curl && <Spline01 className={styles.curl} />}
  </section>
}
